import { useAppBridge } from '@shopify/app-bridge-react';
import React, { useEffect } from 'react';
import { userLoggedInFetch } from '../containers/ShopifyContainer';
export default function AssistantInstaller ({ apiKey } : {apiKey: string}) {
  const app = useAppBridge();
  const fetch = userLoggedInFetch(app);

  useEffect(() => {
    const installAssistantIfNotInstalled = async () => {
      await fetch('/shopify/init-assistant',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            apiKey
          })
        }
      );
    };
    installAssistantIfNotInstalled();
  }, [apiKey, fetch]);

  // at the moment this component installs the assistant without any impact on UI
  return <></>;
}
